import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import OrderTrackingModal from "./components/OrderTrackingModal";

import { getCart, getUser, getCartTotal, clearCart } from "../../utils/cart";
import {
  addToCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
} from "../../utils/cart";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
  apiTest_Url,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";
import { TailSpin } from "react-loader-spinner";

export default function MyOrdersPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [activeFilter, setActiveFilter] = useState("Accepted");
  const [trackingOrder, setTrackingOrder] = useState(null);

  const [status, setstatus] = useState(1);

  const [orders, setorders] = useState([]);

  const [orderDetails, setorderDetails] = useState(null);

const [openOrderId, setOpenOrderId] = useState<number | null>(null);

  useEffect(() => {
    getOrders(1);
    window.scrollTo(0, 0);
  }, []);

  const getOrders = (status: number) => {
    const user: any = getUser();

    const url = `${BaseUrl}/api/finance/getVoucherList`;


    const filter = user?.LedgerID == 1002 ? `{'VchType':3,SubVchType:4,VchStatus:${status}}` : `{'VchType':3,SubVchType:4,VchStatus:${status},'BuyerLedgerID':{$in:[${user?.LedgerID}]}}`

    const body = {
      advancefilters: "",
      pgSize: 10000,
      viewFormat: "columnname",
      index: 1,
      toEmailID: user?.SignInEmail,
      tabErpID: 3017,
      useAtlusSearch: false,
      order: -1,
      filters: filter,
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (
          response?.hasErrors == false &&
          response?.response?.records != null
        ) {
          setLoading(false);
          setorders(response?.response?.records || []);
        } else {
          setorders([]);
          setLoading(false);
        }
      },

      (error: any) => {
        setLoading(false);
        console.log(error);
      },
      (error: any) => {},
    );
  };

  const getOrderDetails = (vchID: number) => {
    setLoading(true);
      setOpenOrderId(vchID); // or order.VchID
    const url = `${BaseUrl}/api/finance/viewBillingVouchers`;

    const body = {
      userID: 1002,
      vchID: vchID,
      tabErpID: 3017,
      collectionDate: "2025-04-01T00:00:00",
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (
          response?.hasErrors == false &&
          response?.response?.records != null
        ) {
          setLoading(false);
          setorderDetails(response?.response?.records || null);
       
        } else {
            setLoading(false);
          setorderDetails(null);
        
        }
      },

      (error: any) => {
        setLoading(false);
        console.log(error);
      },
      (error: any) => {},
    );
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Delivered":
        return "bg-green-100 text-green-700";
      case "Dispatched":
        return "bg-blue-100 text-blue-700";
      case "Accepted":
        return "bg-amber-100 text-amber-700";
      case "Cancelled":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const handlestatus = (filter: string) => {
    setActiveFilter(filter);
 
    if (filter === "Accepted") {
      getOrders(1);
    } else if (filter === "Dispatched") {
      getOrders(5);
    } else if (filter === "Delivered") {
      getOrders(8);
    } else if (filter === "Cancelled") {
      getOrders(18);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">My Orders</h1>

          <div className="flex gap-4 mb-8 overflow-x-auto pb-2">
            {["Accepted", "Dispatched", "Delivered", "Cancelled"].map(
              (filter) => (
                <button
                  key={filter}
                  onClick={() => {
                    handlestatus(filter);
                  }}
                  className={`px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                    activeFilter === filter
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {filter}
                </button>
              ),
            )}
          </div>

          {orders?.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-shopping-bag-line text-8xl text-gray-300 mb-6"></i>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                No orders found
              </h2>
              <p className="text-gray-600 mb-8">
                You haven't placed any orders yet.
              </p>
              <Link
                to="/products"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
              >
                Start Shopping
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ) : (
            <div className="space-y-6">
              {orders?.map((order, i) => (
                <div
                  key={order._id}
                  className="bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden"
                >
                  <div className="bg-gray-50 px-6 py-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div style={{ width: "100%" }}>
                      <div className="flex items-center gap-3 mb-2 just-cont">
                        <div className="flex">
                          <h3 className="text-lg font-bold text-gray-900">
                            {order?.["VchNo"]}
                          </h3>
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(order.status)}`}
                            style={{ marginLeft: 10 }}
                          >
                            {order?.Status}
                          </span>
                          <span
                            onClick={() => {
                             // getOrderDetails(order?.VchID);
                             navigate(`/order/${order?.VchID}`);
                            }}
                            className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(order.status)}`}
                            style={{ marginLeft: 10 }}
                          >
                            {"View Details"}
                          </span>
                        </div>
                        <div className="text-right">
                          {/* <p className="text-sm text-gray-600 mb-1">Total Amount</p> */}
                          <p className="text-1xl font-bold text-gray-900">
                            {" "}
                            ₹{order.TotalBillAmt}
                          </p>
                        </div>
                      </div>
                      <p
                        className="text-sm text-gray-600"
                        style={{ marginTop: -5 }}
                      >
                        Ordered on{" "}
                        {new Date(order?.["VchDate"]).toLocaleDateString(
                          "en-IN",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          },
                        )}
                      </p>
                    </div>
                  </div>

                 {openOrderId === order.VchID && (
                    <div className="p-6">
                      <div className="space-y-4 mb-6">
                        {orderDetails?.ObjItems?.map((item: any, index) => (
                          <div key={index} className="flex gap-4">
                            <div className="w-20 h-20 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                              <img
                                src={
                                  "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                                }
                                alt={item.name}
                                className="w-full h-full object-cover"
                              />
                            </div>
                            <div className="flex-1">
                              <h4
                                className="font-semibold text-gray-900"
                                onClick={() => navigate(`/order/${order.id}`)}
                                style={{ color: "blue" }}
                              >
                                {item.Item}
                              </h4>
                              <p className="text-sm text-gray-600">
                                Quantity: {item.Qty}
                              </p>
                              <p className="text-sm font-bold text-gray-900">
                                ₹{item.MSP * item.Qty}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* <div className="bg-gray-50 rounded-lg p-4 mb-6">
                      <h4 className="font-semibold text-gray-900 mb-2">Delivery Address</h4>
                      <p className="text-sm text-gray-600">{order.deliveryAddress}</p>
                    </div> */}

                      {/* {order.status === 'Delivered' && order.deliveredDate && (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                        <div className="flex items-center gap-2 text-green-700">
                          <i className="ri-check-line text-xl"></i>
                          <span className="font-semibold">
                            Delivered on {new Date(order.deliveredDate).toLocaleDateString('en-IN', { 
                              year: 'numeric', 
                              month: 'long', 
                              day: 'numeric' 
                            })}
                          </span>
                        </div>
                      </div>
                    )} */}

                      {/* {order.status === 'Shipped' && order.expectedDelivery && (
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                        <div className="flex items-center gap-2 text-blue-700">
                          <i className="ri-truck-line text-xl"></i>
                          <span className="font-semibold">
                            Expected delivery by {new Date(order.expectedDelivery).toLocaleDateString('en-IN', { 
                              year: 'numeric', 
                              month: 'long', 
                              day: 'numeric' 
                            })}
                          </span>
                        </div>
                      </div>
                    )} */}

                      {/* {order.status === 'Processing' && order.expectedDelivery && (
                      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                        <div className="flex items-center gap-2 text-amber-700">
                          <i className="ri-time-line text-xl"></i>
                          <span className="font-semibold">
                            Expected delivery by {new Date(order.expectedDelivery).toLocaleDateString('en-IN', { 
                              year: 'numeric', 
                              month: 'long', 
                              day: 'numeric' 
                            })}
                          </span>
                        </div>
                      </div>
                    )} */}

                      {/* <div className="flex flex-col sm:flex-row gap-3">
                      {order.status !== 'Cancelled' && (
                        <button 
                          onClick={() => setTrackingOrder(order)}
                          className="flex-1 px-6 py-3 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
                        >
                          Track Order
                        </button>
                      )}
                      <button className="flex-1 px-6 py-3 bg-white border-2 border-gray-300 text-gray-900 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap"  onClick={() => navigate(`/order/${order.id}`)}>
                        View Details
                      </button>
                      {order.status === 'Delivered' && (
                        <button className="flex-1 px-6 py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors whitespace-nowrap">
                          Reorder
                        </button>
                      )}
                    </div> */}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />

          {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}

      <OrderTrackingModal
        isOpen={trackingOrder !== null}
        onClose={() => setTrackingOrder(null)}
        order={trackingOrder || orders[0]}
      />
    </div>
  );
}
